import { GzCounterWebComponent } from './component/GzCounterWebComponent';
import { WEB_COMPONENT_GZ_COUNTER } from '../../webcomponents.constants';

export { GzCounterWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_COUNTER, GzCounterWebComponent);
